// src/validation/projectBidSchema.js
import * as Yup from 'yup';

// sub-schema de endereço
const addressSchema = Yup.object().shape({
  addressLineOne: Yup.string().max(40).required(),
  addressLineTwo: Yup.string().max(40),
  city:           Yup.string().max(16).required(),
  state:          Yup.string().max(21).required(),
  country:        Yup.string().max(25).required(),
  zipCode:        Yup.string().max(13).required(),
});

// bloco base de projeto
const projectBase = {
  description: Yup.string().max(255).required(),
  type:        Yup.string().max(255).required(),
  status:      Yup.string().max(11).required(),
};

// sub-schemas que reaproveitam o addressSchema
const propertySchema = Yup.object().shape({
  name:    Yup.string().max(255).required(),
  phone:   Yup.string().max(27),
  website: Yup.string().max(255),
  address: addressSchema,
});
const ownershipSchema = Yup.object().shape({
  name:                Yup.string().max(255).required(),
  representativeEmail: Yup.string().max(255),
  representativePhone: Yup.string().max(27),
  representativeName:  Yup.string().max(255),
  representativeCompany: Yup.string().max(255),
  address: addressSchema,
});
const architectSchema = Yup.object().shape({
  companyName:       Yup.string().max(255).required(),
  representativeName: Yup.string().max(255),
  representativePhone: Yup.string().max(27),
  address: addressSchema,
});
const designerSchema = architectSchema; // mesma estrutura que architect

// factory para combinação dinâmica de architect/designer
function makeBidSchema({ withArchitect = true, withDesigner = true } = {}) {
  const shape = { ...projectBase, property: propertySchema, ownership: ownershipSchema };
  if (withArchitect) shape.architect = architectSchema;
  if (withDesigner) shape.designer = designerSchema;
  return Yup.object().shape(shape);
}

// schemas por aba
export const validationSchemaTab1 = Yup.object().shape(projectBase);
export const validationSchemaTab2 = Yup.object().shape({ property: propertySchema });
export const validationSchemaTab3 = Yup.object().shape({ ownership: ownershipSchema });
export const validationSchemaTab4 = Yup.object().shape({ architect: architectSchema });
export const fullSchema            = makeBidSchema({ withArchitect: true,  withDesigner: true });
export const noArchitectSchema     = makeBidSchema({ withArchitect: false, withDesigner: true });
export const basicSchema           = makeBidSchema({ withArchitect: false, withDesigner: false });

// função que escolhe o schema certo baseado em values e na aba selecionada
export function getValidationSchema(values, selectedTab) {
  switch (selectedTab) {
    case '1': return validationSchemaTab1;
    case '2': return validationSchemaTab2;
    case '3': return validationSchemaTab3;
    case '4':
      return (values.architect?.companyName ||
              values.architect?.address?.addressLineOne
        ? validationSchemaTab4
        : basicSchema);
    case '5':
      if (values.designer?.companyName || values.designer?.address?.addressLineOne) {
        return (values.architect?.companyName || values.architect?.address?.addressLineOne
          ? fullSchema
          : noArchitectSchema);
      }
      return basicSchema;
    default:
      return basicSchema;
  }
}


